"use client";
import React, { ReactNode, useEffect } from "react";

const AUTO_QUERIES = ["(color-gamut: p3)", "(prefers-contrast: more)"] as const;

const isAutoLayerActive = (): boolean =>
  AUTO_QUERIES.some((query) => window.matchMedia(query).matches);

const syncRoot = () => {
  const root = document.documentElement;
  if (isAutoLayerActive()) {
    root.setAttribute("data-display-fx", "");
  } else {
    root.removeAttribute("data-display-fx");
  }
};

export const DisplayFxProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    syncRoot();

    const lists = AUTO_QUERIES.map((query) => window.matchMedia(query));
    lists.forEach((list) => list.addEventListener("change", syncRoot));
    return () => {
      lists.forEach((list) => list.removeEventListener("change", syncRoot));
    };
  }, []);

  return <>{children}</>;
};
